/**
 * WithdrawDetailsSection Component
 * 출금 요청 내역 섹션 - 신청금액, 수수료, 입금예정금액 표시
 */
import React from 'react';
import { formatAmount } from '../utils/amountFormatter';
import {
    WithdrawAccountInfo,
    WithdrawableAmount,
    FeeCalculation
} from '../utils/withdrawModal.helpers';
import WithdrawAccountSection from './WithdrawAccountSection';

interface WithdrawDetailsSectionProps {
    /** 신청 금액 */
    numericAmount: number;
    /** 수수료 계산 결과 */
    fees: FeeCalculation;
    /** 계좌 정보 */
    accountInfo: WithdrawAccountInfo;
    /** 출금 가능 금액 정보 */
    withdrawableAmount: WithdrawableAmount;
}

const WithdrawDetailsSection: React.FC<WithdrawDetailsSectionProps> = ({
    numericAmount,
    fees,
    accountInfo,
    withdrawableAmount
}) => {
    return (
        <div className="withdrawal-details">
            <h3 className="section-title">출금요청내역</h3>

            {/* 금액 상세 */}
            <div className="details-grid">
                <div className="detail-row">
                    <span className="detail-label">신청금액:</span>
                    <span className="detail-value">{formatAmount(numericAmount)} 원</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">출금수수료:</span>
                    <span className="detail-value">{formatAmount(fees.transferFee)} 원</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">총 차감금액:</span>
                    <span className="detail-value" style={{ color: '#e74c3c', fontWeight: 600 }}>
                        {formatAmount(fees.totalDeduction)} 원
                    </span>
                </div>
            </div>

            {/* 계좌 정보 */}
            <WithdrawAccountSection
                accountInfo={accountInfo}
                withdrawableAmount={withdrawableAmount}
            />
        </div>
    );
};

export default WithdrawDetailsSection;
